/**
 * @param {import('../../../../../type-definitions').Refinement} refinement - Search result
 * @param {import('../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @returns {string} selected size HTML
 */
export default (refinement, refinementURLBuilder) => {
    if (refinement.options.length < 2) {
        return '';
    }
    const ONE_SIZE = 'one size';
    const selectedSizes = refinement.options.filter(option => option.selected);
    if (window.SitePreferences.STACK_SELECTED_SIZES_ON_PLP) {
        let selectedSizeText =
            selectedSizes.length === 1
                ? window.Resources.SEARCH_REFINEMENT_SIZE_SELECTED
                : window.Resources.SEARCH_REFINEMENT_SIZES_SELECTED;
        selectedSizeText = selectedSizeText.replace('{0}', selectedSizes.length);

        return `
            <li class="value">
                    <div class="value-inner">
                        <span role="link" tabindex="0" class="refinement-relax" data-href="${refinementURLBuilder.getRefinementRemoveURL(
                            refinement.id
                        )}"
                            aria-label="${window.Resources.SEARCH_REFINEMENT_REMOVE}">
                            ${selectedSizeText}
                            <i class="icon icon-close" aria-hidden="true"><!-- icon --></i>
                        </span>
                    </div>
                </li>
        `;
    }

    return selectedSizes
        .map(option => {
            const sizeArr = option.name.split(';');
            let sizeName = sizeArr.join(' / ');

            if (sizeArr && sizeArr.length && sizeArr.length > 1) {
                if (sizeArr[0].toLowerCase() === ONE_SIZE && sizeArr[1].toLowerCase() === ONE_SIZE) {
                    [sizeName] = sizeArr;
                }
            }

            return `
                <li class="value">
                    <div class="value-inner">
                        <span role="link" tabindex="0" class="refinement-relax"
                            data-refinement-id="${refinement.id}" data-is-selected="true"
                            data-refinement-value="${encodeURIComponent(option.value)}"
                            aria-label="${window.Resources.SEARCH_REFINEMENT_REMOVE}"
                            data-href="${refinementURLBuilder.getRefinementValueRemoveURL(
                                refinement.id,
                                option.value
                            )}">
                            ${sizeName}
                            <i class="icon icon-close" aria-hidden="true"><!-- icon --></i>
                        </span>
                    </div>
                </li>
            `;
        })
        .join('');
};
